<template>
    <div>
        <DCard padding>
            <DRow
                class="mb-3"
                align-horizontal="start"
                align-vertical="end"
            >
                <DCol sm="3">
                    <DInput
                        id="search"
                        v-model="filterData.search"
                        :label="__('products.product_packages.index.search')"
                        :placeholder="__('products.product_packages.index.package_name')"
                        @keydown.enter.exact.prevent="filter(productPackages.current_page, filterData)"
                    />
                </DCol>
                <DCol sm="3">
                    <DSelect
                        id="type"
                        v-model="filterData.type"
                        :label="__('products.product_packages.index.package_type')"
                        :options="productPackageTypeOptions"
                    />
                </DCol>
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('messages.actions.filter')"
                        @click="filter(productPackages.current_page, filterData)"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
            <DRow>
                <DCol>
                    <DTable
                        :items="productPackages.items"
                        :fields="fields"
                    >
                        <template #type="{item}">
                            <td>
                                {{ __('products.product_packages.index.types.'+item.type) }}
                            </td>
                        </template>
                        <template #actions="{item}">
                            <td>
                                <div class="actions">
                                    <DButton
                                        :id="`edit_${item.id}`"
                                        icon="pencil"
                                        mini
                                        @click="$inertia.get(editPackage(item.id))"
                                    />
                                    <DButton
                                        v-if="item.can_be_deleted === true"
                                        :id="`btn-delete-${item.id}`"
                                        icon="trash-can-outline"
                                        color="danger"
                                        mini
                                        :disabled="isInLoadingState"
                                        @click="deletePackage(item.id)"
                                    />
                                </div>
                            </td>
                        </template>
                    </DTable>
                    <DPagination
                        v-if="productPackages.last_page > 1"
                        :active-page="productPackages.current_page"
                        :pages="productPackages.last_page"
                        align="center"
                        @update:activePage="changePage"
                    />
                </DCol>
            </DRow>
            <DFabs>
                <DFab
                    id="btn-add-contract-package"
                    icon="plus"
                    :label="__('products.product_packages.index.add_contract_package')"
                    @click="$inertia.get($route('products.product-packages.create'), { isFulfillmentPackage: 0 })"
                />
                <DFab
                    id="btn-add-fulfillment-package"
                    icon="plus"
                    :label="__('products.product_packages.index.add_fulfillment_package')"
                    @click="$inertia.get($route('products.product-packages.create'), { isFulfillmentPackage: 1 })"
                />
            </DFabs>
            <DModal
                v-model:show="showConfirmationModal"
                :title="__('products.product_packages.index.delete_confirmation.title')"
                :message="__('products.product_packages.index.delete_confirmation.message')"
                is-confirm
                is-error
                @close="closeModal"
                @confirm="deleteCallBack"
            />
        </DCard>
    </div>
</template>

<script>

import _ from 'lodash'

export default {
    name: 'ProductPackagesIndex',
    props: {
        productPackages: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productPackageTypes: {
            type: Array,
            default: () => { return [] }
        },
        filters: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            fields: [
                { key: 'name', label: this.__('products.product_packages.index.table.headers.name'), _style: { minWidth: '60%' } },
                { key: 'type', label: this.__('products.product_packages.index.table.headers.type'), _style: { minWidth: '35%' } },
                { key: 'actions', label: '', _style: { minWidth: '5%' } }
            ],
            showConfirmationModal: false,
            deleteCallBack: () => { return {} },
            filterData: _.cloneDeep(this.filters)
        }
    },
    computed: {
        productPackageTypeOptions () {
            const typeOptions = this.productPackageTypes.map(type => {
                return {
                    value: type.value,
                    label: type.label
                }
            })

            typeOptions.unshift({
                value: '',
                label: this.__('products.product_packages.index.select_type')
            })

            return typeOptions
        }
    },
    methods: {
        editPackage (id) {
            return this.$route('products.product-packages.edit', {
                product_package: id
            })
        },
        deletePackage (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(
                    this.$route('products.product-packages.destroy', {
                        product_package: id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => { return {} }
        },
        changePage (page) {
            this.filter(page, this.filterData)
        },
        filter (page, filters, defaultFilters = false) {
            const queryParameters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))
            const routeParameters = {
                saveFilters: true
            }

            if (page > 1) {
                queryParameters.page = page
            }

            if (defaultFilters === true) {
                routeParameters.defaultFilters = true
            }

            this.$inertia.get(this.$route('products.product-packages.index', routeParameters), queryParameters)
        },
        resetFilters () {
            this.filter(1, {}, true)
        }
    }
}
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    grid-gap: 10px;
}
</style>
